import React from "react";
import { Modal, Button, Row, ConfigProvider } from "antd";
// import { WarningFilled } from "@ant-design/icons";
import {
  textTitleMyLearningJourney,
  ColorPrimary,
  textDescPlayModule,
  textAlertQuit,
} from "../config/constant/color/index";
// import useBreakpoint from "antd/lib/grid/hooks/useBreakpoint";

// for translate
import { useTranslation } from "react-i18next";

const ModalQuitScorm = ({
  openModalQuit,
  setModalQuit,
  setCheckModalQuit,
  setConfirmNavigate,
  setListCourseBlocker,
  setCourseIdClicked,
  handleExit,
  handleNo,
  isMobileVersion,
  handShakeDeleteExit
}) => {
  const { t, i18n } = useTranslation();

  // const screens = useBreakpoint();
  // const isMobileVersion = screens.xs;

  const handleExitFromPopup = () => {

    setModalQuit(false)
    handShakeDeleteExit()
  }

  const onCancelHandle = () => {
    const urlNow = window.location.pathname;
    const arrIdAll = urlNow.split("/");

    localStorage.removeItem("scorm-"+arrIdAll[7]);
  }

  return (
    <ConfigProvider
      theme={{
        components: {
          Modal: {
            borderRadiusLG: "16px",
            borderRadiusSM: "16px",
            borderRadiusXS: "16px",
          },
        },
        token: {
          borderRadiusLG: 28,
          fontFamily: "Roboto",
          motionDurationMid: "0.2s",
        },
      }}
    >
      <Modal
        className="modal-logout"
        open={openModalQuit}
        maskClosable="false"
        closeIcon={false}
        width={424}
        onCancel={() => {
          setModalQuit(!openModalQuit);
          setCheckModalQuit(false);
          setConfirmNavigate(false);
          setListCourseBlocker(false);
          setCourseIdClicked(0);
          onCancelHandle();
        }}
        transitionName="ant-fade"
        keyboard
        centered
        footer={
          <Row
            style={{
              justifyContent: "space-between",
              padding: "0 32px 32px",
              gap: isMobileVersion ? "10px" : "0px",
              flexWrap: isMobileVersion ? "nowrap" : "unset",
            }}
          >
            <Button
              key="no-logout"
              className="btn btn-sm btn-secondary"
              style={{
                width: "170px",
                borderRadius: "6px",
                border: "1px solid " + ColorPrimary,
                fontWeight: "500",
                height: "48px",
              }}
              name="btn-cancel-logout-home"
              onClick={() => handleNo()}
            >
              {t("feature.home.pop_up_logout.no")}
            </Button>
            <Button
              key="yes-logout"
              className="btn btn-sm btn-secondary"
              style={{
                width: "170px",
                borderRadius: "6px",
                border: "1px solid " + ColorPrimary,
                fontWeight: "500",
                height: "48px",
              }}
              name="btn-yes-logout-home"
              // onClick={() => handleExit()}
              onClick={() => handleExitFromPopup()}
            >
              {t("feature.home.pop_up_logout.yes")}
            </Button>
          </Row>
        }
      >
        <div
          style={{
            textAlign: "center",
            marginBottom: "23px",
            padding: "29px 32px 0",
          }}
        >
          <p
            style={{
              color: textTitleMyLearningJourney,
              fontWeight: "500",
              fontSize: "22px",
              margin: 0,
            }}
          >
            {t("feature.feature_mylj.popup_quit_module.quit_module_prompt")}
          </p>
        </div>
      </Modal>
    </ConfigProvider>
  );
};

export default ModalQuitScorm;
